import { render } from "./PostContent.vue?vue&type=template&id=4c361110&ts=true"
import script from "./PostContent.vue?vue&type=script&lang=ts"
export * from "./PostContent.vue?vue&type=script&lang=ts"

import "./PostContent.vue?vue&type=style&index=0&id=4c361110&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__